module.exports = __webpack_public_path__ + "static/media/Xiao.930f3ce5.png";